import React from 'react';
import { Marker } from '@react-google-maps/api';

interface Props {
  location: {
    latitude: number;
    longitude: number;
  };
  onClick: () => void;
}

const MapMarker = ({ location, onClick }: Props) => {
  const getMapSize = (w: number, h: number) =>
    typeof window !== 'undefined' && new window.google.maps.Size(w, h);

  const getMapPoint = (x: number, y: number) =>
    typeof window !== 'undefined' && new window.google.maps.Point(x, y);

  const markerProps = {
    position: {
      lat: location?.latitude,
      lng: location?.longitude,
    },
    opacity: 0.87,
    onClick,
  };

  const size = getMapSize(24, 32),
    scaledSize = getMapSize(24, 32),
    labelOrigin = getMapPoint(12, 12);

  const icon = () => {
    return (
      size &&
      scaledSize &&
      labelOrigin && (
        <Marker
          icon={{
            url: '/public-assets/map-pin.svg',
            size,
            scaledSize,
            labelOrigin,
          }}
          {...markerProps}
        />
      )
    );
  };

  return icon();
};

export default React.memo(MapMarker);
